import { clsx } from "clsx";
import type React from "react";
import type { FC } from "react";

import { Callout } from "widgets";

import calloutStyle from "../../../../styles/callout.module.scss";

export interface FormWarningProps {
  children: React.ReactNode;
}

const FormWarning: FC<FormWarningProps> = (props) => {
  return (
    <Callout key={"warn"} className={clsx(calloutStyle.oldWarning)}>
      {props.children}
    </Callout>
  );
};

export { FormWarning };
